import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import Image from "next/image";

import Button from "components/Button";
import Media from "components/Media";
import ScrollViewRevamp from "components/ScrollViewRevamp";
import { useRouter } from "next/router";
import Google from "../../../../../public/refer/reviews/google-logo.png";
import StarRating from "../../../../../public/refer/reviews/5-stars.png";

import styles from "./styles.module.scss";
import { reviews } from "./constants";

const Reviews: FC = () => {
  const router = useRouter();

  return (
    <Content contentClassName={styles.container}>
      <Button
        onClick={() => router.push("refer/#share")}
        className={styles.refer}
        variant="accent"
      >
        Refer
      </Button>
      <Label className={styles.title} variant="h-centered" color="primary">
        Don’t just take our word for it...
      </Label>
      <div className={styles.googleWrapper}>
        <Image alt="" src={Google} layout="fixed" width={191} height={65} />
        <Image alt="" src={StarRating} layout="fixed" width={271} height={45} />
      </div>
      <Media at={["desktop"]}>
        <div className={styles.reviews}>
          {reviews.map(({ src, review, reviewer }) => (
            <div className={styles.review}>
              <Image
                alt=""
                className={styles.reviewImage}
                src={src}
                layout="fixed"
                width={300}
                height={300}
              />
              <Label color="primary" variant="s">
                {review}
              </Label>
              <Label
                color="primary"
                useMarkdown
              >{`__${reviewer}__ | Humming Homes Homeowner`}</Label>
            </div>
          ))}
        </div>
      </Media>
      <Media at={["responsive"]}>
        <ScrollViewRevamp className={styles.scrollView}>
          {reviews.map(({ src, review, reviewer }) => (
            <div className={styles.review}>
              <Image
                alt=""
                className={styles.reviewImage}
                src={src}
                layout="responsive"
              />
              <Label color="primary" variant="s">
                {review}
              </Label>
              <Label
                color="primary"
                useMarkdown
              >{`__${reviewer}__ | Humming Homes Homeowner`}</Label>
            </div>
          ))}
        </ScrollViewRevamp>
      </Media>
    </Content>
  );
};

export default Reviews;
